export const primaryColor = '#c3073f';
export const primaryDarkColor = '#1a1a1d';

export const sucessColor = '#0197f6';
export const infoColor = '#0197f6';
export const errorColor = '#f2af29';
export const warningColor = '#f2af29';
